var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tagView-wrapper relative white"
  }, [_c("a-icon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hanldeBtn,
      expression: "hanldeBtn"
    }],
    staticClass: "absolute pointer tag_btn",
    staticStyle: {
      left: "0"
    },
    attrs: {
      type: "left"
    },
    on: {
      click: function ($event) {
        return _vm.handleScroll(240);
      }
    }
  }), _c("div", {
    ref: "scrollOuter",
    staticClass: "scroll-outer",
    style: _vm.outerWidth
  }, [_c("div", {
    ref: "scrollBody",
    staticClass: "scroll-body absolute",
    style: {
      left: _vm.tagBodyLeft + "px"
    }
  }, _vm._l(_vm.tagList, function (item, index) {
    return _c("router-link", {
      key: item.path,
      ref: "tagWrapper",
      refInFor: true,
      staticClass: "tag-item pointer inline-block",
      class: _vm.isActive(item.name) ? "activeTag" : "",
      attrs: {
        to: item.path
      }
    }, [_c("span", {
      staticClass: "tag-title"
    }, [_vm._v(_vm._s(_vm.$t(item.meta.title)))]), index != 0 ? _c("svg-icon", {
      staticClass: "verticalMiddle tag-icon",
      attrs: {
        icon: "close",
        size: 14
      },
      nativeOn: {
        click: function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.closeTag(item.path, index);
        }
      }
    }) : _vm._e()], 1);
  }), 1)]), _c("a-icon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hanldeBtn,
      expression: "hanldeBtn"
    }],
    staticClass: "absolute pointer tag_btn",
    staticStyle: {
      right: "0"
    },
    attrs: {
      type: "right"
    },
    on: {
      click: function ($event) {
        return _vm.handleScroll(-240);
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };